import { NgModule } from '@angular/core';
import { BasePromotionService, CommonModule, PromotionModule, TransactionModule } from 'common';
import { AccountTransferRoutingModule } from './account-transfer-routing.module';
import { AccountTransferDrawComponent } from './account-transfer-draw/account-transfer-draw.component';
import { SharedModule } from '../../shared/shared.module';
import { AccountTransferPaymentComponent } from './account-transfer-payment/account-transfer-payment.component';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import {
  AccountTransferSubmittedDialogComponent
} from './account-transfer-submitted-dialog/account-transfer-submitted-dialog.component';
import { PromotionService } from "../../promotions/promotion.service";

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    AccountTransferRoutingModule,
    PromotionModule,
    TransactionModule,
  ],
  declarations: [
    AccountTransferDrawComponent,
    AccountTransferPaymentComponent,
    AccountTransferSubmittedDialogComponent,
  ],
  providers: [
    CurrencyPipe,
    PercentPipe,
    {
      provide: BasePromotionService,
      useExisting: PromotionService
    }
  ]
})
export class AccountTransferModule {
}
